module.exports = __webpack_public_path__ + "static/loading-44d1aff032d98588878b9f7196dccc11.webm";